// components/Login.js

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import logo from '../../Components/Header/Images/logo.png';
class Login extends Component {

	render() {
		const { errorMessage } = this.props;
		if (this.props.isAuthorized) {
			return this.props.redirectPath ?
				<Redirect to={{
					pathname: this.props.redirectPath,
					state: { from: this.props.location }
				}} /> :
				<Redirect to={{
					pathname: '/schedule',
					state: { from: this.props.location }
				}} />;
		}

		return (
			<div className="LoginForm">
				<img src={logo} className="ars-logo" alt="ars logo" />
				<input type='text' placeholder="User Name" ref='username' className="form-control" />
				<input type='password' placeholder="Password" ref='password' className="form-control" onKeyPress={event => {
					if (event.key === 'Enter') {
						this.handleClick(event);
					}
				}} />
				<button onClick={(event) => this.handleClick(event)} className="btn btn-primary">
					Login
				</button>

				{errorMessage &&
					<p className="error-msg">{errorMessage}</p>
				}
			</div>
		);
	}

	handleClick(event) {

		const username = this.refs.username.value.trim();
		const password = this.refs.password.value.trim();
		if (username && password) {
			this.refs.password.style.backgroundColor = 'white'
			this.refs.username.style.backgroundColor = 'white'
			const creds = { username: username, password: password };
			this.props.onLoginClick(creds);
		} else if (username && !password) {
			this.refs.password.style.backgroundColor = 'lightpink'
			this.refs.username.style.backgroundColor = 'white'
		} else if (!username && password) {
			this.refs.username.style.backgroundColor = 'lightpink'
			this.refs.password.style.backgroundColor = 'white'
		} else {
			this.refs.password.style.backgroundColor = 'lightpink'
			this.refs.username.style.backgroundColor = 'lightpink'
		}
	}
}

Login.propTypes = {
	// onLoginClick: PropTypes.func.isRequired,
	// errorMessage: PropTypes.string
};

const mapStateToProps = (state) => {
	return {
		isAuthorized: state.auth.isAuthenticated,
		redirectPath: state.auth.redirectPath
	};
};

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/Components/Auth/Login.js